<app-header></app-header>
<app-sidebar></app-sidebar>
<div>
  <!-- Globos (por encima de todo) -->
  <!-- <app-balloons-overlay *ngIf="showLayer"></app-balloons-overlay> -->
  <section id="content" class="main-section">
    <div class="container" [@routeAnimation]="getAnimationData()">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
    <app-footer></app-footer>
  </section>
</div>



<!-- <app-header />
<app-sidebar />
<section id="#content" class="main-section">
  <div class="container" [@routeAnimation]="getAnimationData()">
    <router-outlet #outlet="outlet" />
  </div>
  <app-footer />
</section> -->